import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import { analyticsMetadataPropTypes } from 'site-react/core/Analytics';
import UnstyledButton from 'site-react/core/UnstyledButton';
import MaterialIcon from 'site-react/core/Icon/MaterialIcon';
import theme from 'site-react/theme';

const navigationPhoneButtonStyle = css`
  background: none;
  border: 0;
  color: ${theme.colors.black};
  display: inline-block;
  height: ${theme.spacing.minimumTargetSize}px;
  padding: 0;
  text-align: center;
  vertical-align: top;
  width: ${theme.spacing.minimumTargetSize}px;
  @media (min-width: ${theme.breakpoints.md}px) {
    display: none;
  }

  &:hover,
  &:focus {
    color: ${theme.colors.neutral800};
  }

  &:active {
    color: ${theme.colors.neutral700};
  }
`;

const navigationPhoneIconStyle = css`
  font-size: ${theme.font.size.lg};
  line-height: ${theme.spacing.minimumTargetSize}px;
`;

const NavigationPhoneButton = ({ analyticsMetadata, label, phoneNumber }) => (
  <UnstyledButton
    analyticsMetadata={analyticsMetadata}
    className={navigationPhoneButtonStyle}
    elementType="a"
    label={label}
    href={`tel:+${phoneNumber}`}
  >
    <MaterialIcon className={navigationPhoneIconStyle} iconType="phone" />
  </UnstyledButton>
);

NavigationPhoneButton.defaultProps = {
  analyticsMetadata: {},
  label: '',
};

NavigationPhoneButton.propTypes = {
  /**
   * Additional metadata that we want to attach to the analytics event on click.
   * All properties are optional.
   */
  analyticsMetadata: analyticsMetadataPropTypes,

  /**
   * Label text that represents this link.
   * This will be the main prop sent to analytics;
   */
  label: PropTypes.string,

  /**
   * Phone number is important in order for the phone action to take place.
   */
  phoneNumber: PropTypes.string.isRequired,
};

export default NavigationPhoneButton;
